module.exports = __webpack_public_path__ + "img/BannerNew.036d723a.png";